window.scrollInfinity = {
	paginationNumeric: 1,
	buscarequest: false,
	imoveisVisiveisMerged: {},
	urlToArray: url => {
		var request = {};
		var pairs = url.substring(url.indexOf('?') + 1).split('&');
		for (var i = 0; i < pairs.length; i++) {
			if(!pairs[i])
				continue;
			var pair = pairs[i].split('=');
			request[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
		}
		return request;
	},
	init: (footerElement, renderImoveisElement, feedbackElement) => {

		if(typeof(footerElement) == 'undefined'){ 
			console.warn('Ops, você precisa informar qual é o footer para o ScrollInfinity funcionar.');
			return false;
		}
		if(typeof(renderImoveisElement) == 'undefined'){
			console.warn('Ops, você precisa informar qual é o elemento que vai receber os imóveis para o ScrollInfinity funcionar.');
			return false;
		}

		Boss.evts.add('scroll', document, f => {
			var tamanhoScreen = window.scrollY + footerElement.offsetHeight + objetivaa.offsetHeight;
			
			if(scrollInfinity.buscarequest){
				return false;
			}
			
			Boss.delayPersistent2(f => {
				
				if(tamanhoScreen >= (document.body.offsetHeight - 350)){
					return false;
				}

				if(window.scrollY >= (footerElement.offsetTop - footerElement.offsetHeight * 2)){
					
					if(feedbackElement){
						feedbackElement.innerHTML = '<p class="text-center">Aguarde...</p>';
					}
					scrollInfinity.paginationNumeric += 1;
	
					var tempFields = window.location.href+payloadBusca.payload;
					
					tempFields = scrollInfinity.urlToArray(tempFields);
					tempFields['pag'] = scrollInfinity.paginationNumeric;
	
					Boss.ajax({
						'url': '/buscar/scroll',
						'data': tempFields,
						'dataType': 'json',
						'done': function(rtn){
							if(feedbackElement){
								feedbackElement.innerHTML = '';
							}
							

							if(typeof(setimoveisVisiveis) !== 'undefined' && typeof(getImovelImagens) !== 'undefined'){
								loadImages(rtn.imagensVisiveis).then(images => activeSetaImagens()).catch(e => console.error('Ops, parece que algo não deu certo', e));
								setimoveisVisiveis(Object.assign(scrollInfinity.imoveisVisiveisMerged, imoveisVisiveis, rtn.imoveisVisiveis));
								getImovelImagens();	
							}
							
							if(renderImoveisElement){
								renderImoveisElement.innerHTML = renderImoveisElement.innerHTML + rtn.data;
							}
	
	
							/* Isso é para pausar a busca por scroll */
							if(rtn['data'].length <= 50){
								scrollInfinity.buscarequest = true;
							}
						}
					});
	
				}
			}, 500, 'scrollInfinity');
		});
	}
};